import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import { useLocation } from 'react-router-dom';
import { isWebviewRenderType } from 'Utils/webviewMode';


const CampaignDetail = loadable(() => import('./CampaignDetail'), {
  fallback: <Loading />
});

const CampaignList = loadable(() => import('Pages/CampaignList'), {
  fallback: <Loading />
});

const AsyncCampaignDetail = props => {
  const location = useLocation();
  const pathname = location.pathname;
  const pathSegments = pathname.split('/');
  const detail = pathSegments[3];
  const isWebview = isWebviewRenderType(location.search);

  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: detail === 'detay' && isWebview && (props.userAgent.device?.type === 'mobile') ? 'none' : 'full',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} bg-solid-grey hide-betslip hide-sticky-navigation`
      }
    }
  };

  const { campaignId } = props.match.params;

  const pageContent = campaignId
    ? <CampaignDetail { ...props } helmet={ pageConfig.helmet }/>
    : <CampaignList { ...props } helmet={ pageConfig.helmet } />;

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      { pageContent }
    </ApplicationLayout>
  );
};

AsyncCampaignDetail.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncCampaignDetail;
